import { Reply } from "@/types";
import AppBox from "../AppBox";
import AppText from "../AppText";
import ReplyEditor from "./ReplyEditor";

interface RepliesGroupProps {
  title?: string;
  description?: string;
  replies: Reply[];
  form: Record<number, Partial<Reply>>;
  onChange: (id: number, field: keyof Reply, value: any) => void;
  onToggleActive: (id: number) => void;
  isNoPhone?: boolean;
  noPhoneActive?: boolean;
  onToggleNoPhone?: (active: boolean) => void;
  disabled?: boolean;
  buttonSlot?: React.ReactNode;
  isAfterHours?: boolean;
}

export const RepliesGroup: React.FC<RepliesGroupProps> = ({
  title,
  description,
  replies,
  form,
  onChange,
  onToggleActive,
  isNoPhone,
  disabled = false,
  buttonSlot,
  isAfterHours,
}) => {
  const initial = replies.find(r => !r.is_followup);
  const followups = replies.filter(r => r.is_followup);

  return (
    <AppBox column>
      {((isNoPhone && initial) || initial) && (
        <AppBox column className="py-4 pl-6 gap-2">
          <AppText variant="h5">{title}</AppText>
          {description && <AppText variant="caption">{description}</AppText>}
        </AppBox>
      )}
      <AppBox column className={disabled ? "opacity-50 pointer-events-none" : ""}>
        {initial && !isNoPhone
          ? <ReplyEditor
              reply={initial}
              form={form[initial.id] || {}}
              onChange={onChange}
              disabled={disabled || !initial?.active}
              onToggleActive={() => disabled ? undefined : onToggleActive(initial.id)}
              isAfterHours={isAfterHours}
              buttonSlot={buttonSlot}
            />
          : isNoPhone && initial
            ? <ReplyEditor
                reply={initial}
                form={form[initial.id] || {}}
                onChange={onChange}
                disabled={disabled || !initial?.active}
                onToggleActive={() => disabled ? undefined : onToggleActive(initial.id)}
              />
            : null
        }
        {followups.map((reply, index) => (
          <ReplyEditor
            key={reply.id}
            reply={reply}
            index={index}
            form={form[reply.id] || {}}
            onChange={onChange}
            isNoPhone={isNoPhone}
            onToggleActive={() => disabled ? undefined : onToggleActive(reply.id)}
            disabled={disabled || !(form[reply.id]?.active ?? !reply.active)}
          />
        ))}
      </AppBox>
    </AppBox>
  );
};